import { wrapWithLayout } from "./src/wrapWithLayout"
import "./src/styles/global.css"

export const wrapPageElement = wrapWithLayout(false)
